import { replaceUrlPlaceholders } from "react-utils";
import axiosCoralie from "../axios-setup";
import { default as axios } from "axios";

const CONF = window?.confPub;
const CORRESPONDANTS_ROUTES = CONF?.ROUTES?.CORRESPONDANTS

export const rechercheAnnuaireCorrespondants = async (departementCodePostal, nom, prenom) => {

    const RECHERCHE_ANNUAIRE_URL = CORRESPONDANTS_ROUTES?.RECHERCHE_ANNUAIRE;
    const QUERY_PARAMS = CORRESPONDANTS_ROUTES?.QUERY_PARAMS

    const queryParms = replaceUrlPlaceholders(QUERY_PARAMS, {
        departement: departementCodePostal,
        nom: nom ?? '',
        prenom: prenom ?? ''
    });

    try {

        const resp = await axiosCoralie.get(RECHERCHE_ANNUAIRE_URL + queryParms)

        if (resp?.data && resp?.data?.code !== "ECLD_RECHANNUCOR_ERR1") {

           return resp.data
        } else {

           return  []
        }

    } catch (err) {
        throw err
    }
}

export const getInfosCorrespondant = async (numPersCorr) => {

    const urlWithNumPersCorr = replaceUrlPlaceholders(CORRESPONDANTS_ROUTES?.GET_INFOS_CORRESPONDANT, { numPersCorr: numPersCorr })

    try {
        const resp = await axiosCoralie.get(urlWithNumPersCorr)

        if (resp?.data) {

            console.log("resp?.data")
            console.log(resp?.data)

            return resp?.data

        } else {

            return []
        }

    } catch (err) {
        throw err
    }
}